// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2319":"c5d7f453","5917":"79131266","6852":"79131266","9661":"79131266"}[chunkId] + ".chunk.css";
};